import React from 'react';
import cn from 'classnames';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('EXCHANGE_RATES_TOOLBAR', LOG_LEVELS.DEBUG);

class ExchangeRatesToolbar extends React.Component {

    constructor(props) {
        super(props);
        log.debug('constructor(): ExchangeRatesToolbar: ', props);
    }
    
      onCheckboxClickHandler(event){
        this.props.genericCheckboxHandlerFactory(event.target.checked)
      }


    render() {
        log.debug('render(): ', this.props);
        const importButtonClasses = cn('primary', 'mr10', {'disabled' : this.props.disableImport});
        return (
             <div className='mb15' data-test="component-exchange-rates-toolbar-main">
                <ReadOnlyWrapper>
                    <fieldset>
                        <input 
                            className="checkbox"
                            name="removeExistingExchangeRates"
                            type="checkbox" 
                            checked={this.props.removeExistingRates} 
                            onClick={this.onCheckboxClickHandler.bind(this)}
                        />
                        <label className="checkbox"><LanguageStringResolver string='exchangeRatesImportModal_RemoveExistingRatesBeforeFetchingNewRates' /></label>
                    </fieldset>
                    <br/>
                    {this.props.enableImportExchangeRatesViaERS ? (
                        <button className={importButtonClasses} disabled={this.props.disableImport} data-test="link-import-operation-control" onClick={this.props.onImportOperationClick}>
                            <LanguageStringResolver string='exchangeRatesToolbar_ImportViaOperationService' />
                        </button>
                    ) : (
                        <button className={importButtonClasses} disabled={this.props.disableImport} data-test="link-import-control" onClick={this.props.onImportClick}>
                            <LanguageStringResolver string='exchangeRatesToolbar_Import' />
                        </button>
                    )}
                    <button className={importButtonClasses} disabled={this.props.disableImport} data-test="link-import-xml-control" onClick={this.props.onImportXmlClick}>
                        <LanguageStringResolver string='exchangeRatesToolbar_XmlImport' />
                    </button>
                </ReadOnlyWrapper>
             </div>
        );
    }
}


ExchangeRatesToolbar.defaultProps = {
    onImportClick: () => {},
    onImportXmlClick: () => {},
    onImportOperationClick: () => {},
    genericCheckboxHandlerFactory:()=>{},
    disableImport: false,
    enableImportExchangeRatesViaERS: false,
}

export default ExchangeRatesToolbar;
